import { useEffect, useRef } from "react";
import useAuthUser from "./useAuthUser";

export default function useOnAuthorised(cb: () => void) {
  const { user } = useAuthUser();
  const oldVal = useRef(user);
  useEffect(() => {
    if (!oldVal.current && user) {
      cb();
    }
    oldVal.current = user;
  });
}
